import { initBrowserSentry } from '../sentry/init-browser-sentry'
import Alpine from 'alpinejs'
import precognition from 'laravel-precognition-alpine'
import AOS from 'aos'
import 'aos/dist/aos.css'
import dataInNumbersComponent from './c-data-in-numbers'
import { observersStore } from '../store/observers'
import slideComponent from './c-slider'
import paginationComponent from './c-pagination'
import { appStore } from './store/app'
import { guardLinkStore } from './store/guard-link-store'

initBrowserSentry()

Alpine.data('dataInNumbersComponent', dataInNumbersComponent)
Alpine.data('slideComponent', slideComponent)
Alpine.data('paginationComponent', paginationComponent)
Alpine.store('observers', observersStore)
Alpine.store('app', appStore)
Alpine.store('guardLinkStore', guardLinkStore)
Alpine.plugin([precognition])
window.Alpine = Alpine
Alpine.start()

document.addEventListener('click', (e) => {
    const link = e.target.closest('a')
    if (!link) return
    if (link.target !== '_blank') return
    if (!link.href.startsWith('http')) return
    if (link.dataset.withGuard !== 'true') return
    e.preventDefault()
    guardLinkStore.openGuard(link.href)
})

function addAosToClasses(classesConfig) {
    for (const [className, animation] of Object.entries(classesConfig)) {
        document.querySelectorAll(className).forEach((element) => {
            element.setAttribute('data-aos', animation)
        })
    }
}

window.addEventListener('DOMContentLoaded', () => {
    addAosToClasses({
        '.prose': 'fade-up',
        '.c-section-info': 'fade-up',
        '.c-cta-contact-hero .c-inner': 'fade-up',
        '.c-product-entry': 'fade-up',
        '.c-people-profile': 'fade-up',
        '.c-updates-entry': 'fade-up',
        '.c-data-in-numbers-single': 'fade-up',
        '.c-image': 'fade',
    })

    AOS.init({
        offset: 24,
        duration: 400,
        easing: 'ease-in-out',
        once: true,
    })
})
